export const state = () => ({
  currResource: {},
})

export const mutations = {
  setCurrResource (state, currResource) {
    state.currResource = currResource
  },
}

export const actions = {
  updateCurrResource ({ commit }, currResource) {
    commit('setCurrResource', currResource)
  },
}
